import React, {Component} from 'react';

import screen from '../images/cancellations-noshows-modal.jpg';
import {SanitizeClassNames} from '../common';

import './NoShow.css';
import {Input, Button, SelectList} from '../components/FormUI';
import AppointmentService from '../api/services/AppointmentService';
import moment from 'moment';
import DateHelper from '../components/DateHelper';

import Appointment from '../api/Appointment';
import User from '../api/User';
import Clinic from '../api/Clinic';
import AccountService from '../api/services/AccountService';
import {ActionModal} from '../components/BioPedModal';
import NewAppForm from './Appointments/forms/NewAppForm';
import ClinicPatientList from '../components/datalists/ClinicPatientList';


import Fuse from 'fuse.js';
import CalendarView from "./CalendarView";

const appService = new AppointmentService();
const account = new AccountService();

const searchOpts = {
	threshold: 0.4,
	keys: ['client.firstname', 'client.lastname']
}


/*function parseIntoGroups(list){
    let json = list;
    let groups = {};
    let items = [];
    json.sort((a, b) => {
        if(moment(a.start).isSame(moment(b.start)))return 0;
        return (moment(a.start).isBefore(moment(b.start)))? -1:1;
    });
    for(let i=0; i < json.length; i++){
        let app = json[i];
        let groupId = moment(app.start).format('ddd MMM D');
        if(groups[groupId] === undefined){
            groups[groupId] = [];
        }
        groups[groupId].push(<AppListItem app={json[i]} onReschedule={this.} />);
    }

    for(let p in groups){
        items.push(
            <div className='list-group'>
                <h2>{p}</h2>
                {groups[p]}
            </div>
        )
    }

    return items;
}*/

export default class NoShow extends Component {
	state = {};
	list = null;

	getSearchRange(duration) {
		let start = moment().subtract(duration);
		let end = moment();
		return [start, end];
	}

	handleReschedule = (app) => {
		const newapp = Object.assign({}, app);
		delete newapp.appointmentId;
		this.setState({app: newapp, isOpen: true});
	}

	handleClose = () => {
		this.setState({app: null, isOpen: false});
	}

	onEditComplete = () => {
		this.handleClose();
		CalendarView.Refresh();
	}

	parseIntoGroups(list) {
		let json = list;
		let groups = {};
		let items = [];
		json.sort((a, b) => {
			if (moment(a.start).isSame(moment(b.start))) return 0;
			return (moment(a.start).isBefore(moment(b.start))) ? -1 : 1;
		});
		for (let i = 0; i < json.length; i++) {
			let app = json[i];
			let groupId = moment(app.start).format('ddd MMM D, YYYY');
			if (groups[groupId] === undefined) {
				groups[groupId] = [];
			}
			groups[groupId].push(<AppListItem id={i} app={json[i]} onReschedule={this.handleReschedule}/>);
		}

		for (let p in groups) {
			items.push(
				<div id={p} className='list-group'>
					<h2>{p}</h2>
					{groups[p]}
				</div>
			)
		}

		if (items.length === 0) {
			items.push(<div className='noshow-no-items'>No items found!</div>)
		}

		return items;
	}

	/*getList = (duration)=>{
		let range = this.getSearchRange(duration);
		let options = {
			StartDate: DateHelper.dateToString(range[0]),
			EndDate: DateHelper.dateToString(range[1]),
			AppointmentStatus : 'Cancelled'
		}
		this.setState({isBusy:true})
		appService.search(options).then((cancelledResults) => {
			options.AppointmentStatus = 'No-Show';
			//console.log("Cencelled Appointments:", cancelledResults);
			return appService.search(options).then((noShowResults) => {
				let cr = cancelledResults || [];
				let nr = noShowResults || [];
				//console.log("No Shows:", noShowResults);
				return cr.concat(nr);
			})
		}).then((json) => {
			console.log("Results Found!", json)

			let list = this.parseIntoGroups(json);
			this.setState({list:list, isBusy:false})
		})
	}*/

	getList = (range) => {
		//let range = this.getSearchRange(duration);
		let options = {
			StartDate: DateHelper.dateToString(range[0]),
			EndDate: DateHelper.dateToString(range[1]),
			AppointmentStatus: 'Cancelled'
		}
		this.setState({isBusy: true})
		appService.search(options).then((cancelledResults) => {
			options.AppointmentStatus = 'No-Show';
			//console.log("Cencelled Appointments:", cancelledResults);
			return appService.search(options).then((noShowResults) => {
				let cr = cancelledResults || [];
				let nr = noShowResults || [];
				//console.log("No Shows:", noShowResults);
				return cr.concat(nr);
			})
		}).then((json) => {
			console.log("Results Found!", json)

			this.fuse = new Fuse(json, searchOpts);

			this.list = json;

			this.displayList(json);

			this.setState({isBusy: false})
		})
	}

	displayList = (list) => {
		this.setState({list: this.parseIntoGroups(list)});
	}

	rangeOptions = [
		{label: 'This Week', value: 'this week'},
		{label: 'Last Week', value: 'last week'},
		{label: 'This Month', value: 'this month'},
		{label: 'Last 3 Months', value: '3 months'}
	]

	handleRangeChange = (range) => {
		console.log("Range:", range);
		if (!range) return;
		let duration = moment.duration(1, 'week');
		let r = [];
		switch (range.value) {
		case 'this week':
			r = DateHelper.GetWeekRange();
			break;
		case 'last week':
			let weekStart = moment().subtract(1, 'week').startOf('week');
			let weekEnd = moment().endOf('day');
			r = [weekStart, weekEnd];
			break;
		case 'this month':
			r = [moment().startOf('month'), moment().endOf('month')];
			break;
		case '3 months':
			let monthsAgo = moment().startOf('month').subtract(3, 'months').startOf('month');
			r = [monthsAgo, moment().endOf('week')];
			break;
		}

		console.log("NoShow Range:", r[0].toString() + ' - ' + r[1].toString());

		this.getList(r);
	}

	handleSearch = (val) => {
		if (this.fuse && val) {
			let result = this.fuse.search(val);
			console.log("Searching:", val);
			console.log("Search:", result);
			this.displayList(result);
		} else {
			this.displayList(this.list)
		}
	}

	render() {
		return (
			<div className='noshow-view'>
				<div className='container'>
					<div className='table hmax align-middle'>
						<div>
							<div>
								<ColorBoxCaption color='#C60E0E'>Cancellations</ColorBoxCaption>
								<ColorBoxCaption color='#E1E1E1'>No Shows</ColorBoxCaption>
							</div>
							<div className='align-right'><span className='close-btn'
							                                   onClick={this.props.onRequestClose}>Close</span></div>
						</div>
					</div>
					<div className='search-bar table hmax align-middle'>
						<div>
							<div>
								{/*<Button onClick={this.getList} caption='refresh' isBusy={this.state.isBusy} />*/}
								<SelectList placeholder='Select Time Frame' options={this.rangeOptions}
								            onChange={this.handleRangeChange} isLoading={this.state.isBusy}/>
							</div>
							<div>
								<Input onChange={this.handleSearch} placeholder="Seacrh List"
								       className='no-show-search-list'/>
							</div>
						</div>
					</div>
				</div>
				<div className='container list-holder'>
					{this.state.list}
				</div>

				<ActionModal title="Appointment - Re-Schedule" close='Cancel' isOpen={this.state.isOpen}
				             onRequestClose={this.handleClose}>
					<NewAppForm appointment={this.state.app} onSave={this.onEditComplete}/>
				</ActionModal>
			</div>
		)
	}
}

class ColorBoxCaption extends Component {
	render() {
		let style = {
			backgroundColor: this.props.color
		}
		return (
			<div className={SanitizeClassNames(this, 'color-box-caption')}>
				<div className='box' style={style}></div>
				<div className='box-content'>{this.props.children}</div>
			</div>
		)
	}
}

class AppListItem extends Component {

	handleReschedule = () => {
		if (this.props.onReschedule) {
			this.props.onReschedule(this.props.app);
		}
	}

	render() {
		let app = this.props.app;
		let client = new User(app.client);
		let time = Appointment.FormatTimeRange(app);
		let clinic = new Clinic(app.clinicId);
		let doctor = clinic.getDoctor(app.userId);
		return (
			<div className={'app-list-item table hmax align-top layout-fixed ' + app.status.toLowerCase()}>
				<div>
					<div>{client.fullName}<br/>{time}</div>
					<div>{account.clinicName}</div>
					<div>{doctor.fullName}</div>
					<div>{app.status}<br/><a onClick={this.handleReschedule}>Reschedule</a></div>
				</div>
			</div>
		)
	}
}




// WEBPACK FOOTER //
// ./src/views/NoShow.js